
// TODo : merge this with <progress/>
import './Expert.scss';

import CheckIcon from '@mui/icons-material/Check';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {useLocation, useNavigate } from 'react-router-dom';

import { Step2ExpertProgressionDraw, Svg1Step4, SvgStep1, SvgStep3 } from '../../../data/SVGs';
import useStep from '../../../hooks/useStep';
import { NotselectedButtonLink, SelectedButtonLink } from '../../../Styles/componentStyles';

const DrawSideBar = () => {
    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();
    const step=useStep();
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const dsiplayEtatIcon=(curr)=>{
        let lastNumberInCurrentPath;
        if(currentPath=='completeProfile')
            lastNumberInCurrentPath=0;
        else
            lastNumberInCurrentPath=currentPath.charAt(currentPath.length-1);

        if(step == curr)
            return (

                <div className='frame5Client'>
                    <div className='frame6Client'>
                        {curr==0 ? '1' : curr}
                    </div>
                </div>
            );
        else if(Number(lastNumberInCurrentPath)> curr || step > curr)
            return (
                <div className='frame17Client'>
                    <div className='frame18Client'>
                        <CheckIcon style={{color:'white'}} />
                    </div>
                </div>
            );
        else
            return (
                <div className='frame12Client'>
                    <div className='frame15Client'>
                        {curr==0 ? '1' : curr}
                    </div>
                </div>
            );

    };

    return (

        <div className='GrandBoxStep2'>
            <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
                <div className='StepsSecondPart'>
                    <div className='frame4Client'>
                        <div className='frame9Client'>
                            <Button
                                variant='text'
                                onClick={()=>{navigate('/expert/completeProfile');}}
                                disabled={(!(currentPath == 'completeProfile' ) && Number(step)>=0) ? false : true}
                                style={(!(currentPath == 'completeProfile' ) && Number(step)==0) ? SelectedButtonLink:NotselectedButtonLink }
                                startIcon={dsiplayEtatIcon(0)}
                            >
                                {i18n.t('Profil')}
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='Rect1'>
                    <div className='LineRect1'>
                    </div>
                </div>
                <div className='frame11Client'>
                    <div className='frame9Client'>

                        <Button
                            variant='text'
                            onClick={()=>{navigate('/expert/completeProfile/step2');}}
                            disabled={(!(currentPath == 'step2' ) && Number(step)>=2) ? false : true}
                            style={(!(currentPath == 'step2' ) && Number(step)==2) ?SelectedButtonLink: NotselectedButtonLink}
                            startIcon={dsiplayEtatIcon(2)}
                        >
                            {i18n.t('Données CV')}
                        </Button>

                    </div>
                </div>

                <div className='Rect2'>
                    <div className='LineRect1'>
                    </div>
                </div>
                <div className='frame16Client'>
                    <div className='frame9Client'>

                        <Button
                            variant='text'
                            onClick={()=>{navigate('/expert/completeProfile/step3');}}
                            disabled={(!(currentPath == 'step3' ) && Number(step)>=3) ? false : true}
                            style={(!(currentPath == 'step3' ) && Number(step)==3) ? SelectedButtonLink :NotselectedButtonLink}
                            startIcon={dsiplayEtatIcon(3)}
                        >
                            {i18n.t('Préférences')}
                        </Button>

                    </div>
                </div>
                <div className='Rect3'>
                    <div className='LineRect1'>
                    </div>
                </div>
                <div className='Steps4SecondPart'>

                    <div className='frame9Client'>

                        <Button
                            variant='text'
                            onClick={()=>{navigate('/expert/completeProfile/step4');}}
                            disabled={(!(currentPath == 'step4' ) && Number(step)>=4) ? false : true}
                            style={(!(currentPath == 'step3' ) && Number(step)==4) ? SelectedButtonLink : NotselectedButtonLink}
                            startIcon={dsiplayEtatIcon(4)}
                        >
                            {i18n.t('Société')}
                        </Button>

                    </div>
                </div>
            </div>

            {currentPath=='completeProfile' &&
                <div style={{display:'flex'}}>
                    <SvgStep1 />
                </div>
            }
            {currentPath=='step2' &&
                <div style={{display:'flex'}}>
                    <Step2ExpertProgressionDraw />
                </div>

            }
            {currentPath=='step3' &&
                <div style={{display:'flex'}}>
                    <SvgStep3 />
                </div>
            }
            {currentPath=='step4' &&
                <div style={{display:'flex'}}>
                    <Svg1Step4 />
                </div>
            }

        </div>
    );
};

export default DrawSideBar;